import { render, staticRenderFns } from "./PurchasingRejectedLog.vue?vue&type=template&id=72c413a9&"
import script from "./PurchasingRejectedLog.vue?vue&type=script&lang=js&"
export * from "./PurchasingRejectedLog.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingRejectedLog.vue?vue&type=style&index=0&id=72c413a9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports